import { render, staticRenderFns } from "./addinviteviews.vue?vue&type=template&id=c21adbb6"
import script from "./addinviteviews.vue?vue&type=script&lang=js"
export * from "./addinviteviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports